import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import SettingsView from "@/components/settings/SettingsView";
import { Route as OrgRoute } from "./$orgSlug";
import { trpc } from "@/lib/trpc";
import { settingsSearchSchema, type SettingsSearch } from "@/lib/search-params";
import { useSearchPatch } from "@/lib/search-nav";

// No loader prefetch: each Settings section fetches only its own data when it
// becomes the active section (issue 17), so opening Settings never eagerly runs
// every section's query. The viewer is already cached by the parent $orgSlug
// route, so reading it here costs no extra request.
export const Route = createFileRoute("/_authenticated/$orgSlug/settings")({
  validateSearch: settingsSearchSchema,
  component: OrgSettingsPage,
});

function OrgSettingsPage() {
  const { tab, account } = Route.useSearch();
  const { currentOrg } = OrgRoute.useLoaderData();
  const { data: viewer } = useSuspenseQuery(trpc.organization.viewer.queryOptions());
  const patchSearch = useSearchPatch<SettingsSearch>({ replace: true });

  return (
    <SettingsView
      org={currentOrg}
      viewer={viewer}
      tab={tab}
      auditAccount={account}
      onTabChange={(nextTab) => patchSearch({ tab: nextTab })}
    />
  );
}
